// extracted by mini-css-extract-plugin
export default {"root":"eJtg5","mobile":"YHiLx"};